export default {"src":"/_next/static/media/cook-with-large-grey-chat-box.dc592a76.svg","height":359,"width":301};